import { Outlet } from 'react-router-dom';

import { Sidebar } from './sidebar';
import { TopBar } from './top-bar';

import { CommandPalette } from '@/components/common/command-palette';
import { IssueDrawer } from '@/components/domain/issue-drawer';

export function AppLayout() {
  return (
    <div className="flex h-full min-h-screen w-full bg-muted/20">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <IssueDrawer />
    </div>
  );
}
